import React from 'react';
import HeroAlt from '../components/HeroAlt';
import Industries from '../components/Industries';
import UseCases from '../components/UseCases';
import ValueProps from '../components/ValueProps';
import Solutions from '../components/Solutions';
import Platforms from '../components/Platforms';
import AnalyticsSnapshot from '../components/AnalyticsSnapshot';
import DemoInterface from '../components/DemoInterface';
import SignupEmbed from '../components/SignupEmbed';
import { useTranslation } from '../i18n/useTranslation';
import { ArrowRightIcon, MailIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import Button from '../components/Button';
const Home1Page = () => {
  const {
    t
  } = useTranslation();
  return <main data-id="element-3166">
      <HeroAlt data-id="element-3167" />
      <Industries data-id="element-3168" />
      <UseCases data-id="element-3169" />
      <ValueProps data-id="element-3170" />
      <Solutions data-id="element-3171" />
      <Platforms data-id="element-3172" />
      {/* GPT Stores Promo Banner */}
      <div className="bg-gradient-to-r from-indigo-100 to-purple-100 py-8 border-y border-indigo-200" data-id="element-3173">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between" data-id="element-3174">
          <div className="mb-4 md:mb-0 md:mr-8" data-id="element-3175">
            <h3 className="text-2xl font-bold text-indigo-900 mb-2" data-id="element-3176">
              {t('sections.gptPromo.title')}
            </h3>
            <p className="text-indigo-700 max-w-2xl" data-id="element-3177">
              {t('sections.gptPromo.description')}
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-4" data-id="element-3178">
            <a href="mailto:info@shopilots.com" className="inline-flex items-center justify-center px-6 py-3 rounded-md bg-indigo-600 text-white hover:bg-indigo-700 shadow-md hover:shadow-lg transition-all duration-300 font-medium whitespace-nowrap" data-id="element-3179">
              <MailIcon className="mr-2 h-4 w-4" data-id="element-3180" />
              {t('buttons.callUs')}
            </a>
            <Link to="/gpt-store" data-id="element-3181">
              <Button variant="outline" size="lg" className="whitespace-nowrap border-2 border-indigo-300 hover:border-indigo-400 text-indigo-700" data-id="element-3182">
                {t('buttons.learnMore')}{' '}
                <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-3183" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
      <AnalyticsSnapshot data-id="element-3184" />
      <DemoInterface data-id="element-3185" />
      <SignupEmbed data-id="element-3186" />
    </main>;
};
export default Home1Page;